import CouponListPage from "./pages/CouponListPage";
import CouponAddPage from "./pages/CouponAddPage";
import CouponDetailPage from "./pages/CouponDetailPage";
import CouponUsagePage from "./pages/CouponUsagePage";

export const couponRoutes = (prefix = "coupons") => [
  { name: "CouponAddPage", path: `${prefix}/add`, component: CouponAddPage },
  {
    name: "CouponUsagePage",
    path: `${prefix}/:id/usages`,
    component: CouponUsagePage
  },
  {
    name: "CouponDetailPage",
    path: `${prefix}/:id`,
    component: CouponDetailPage
  },
  { name: "CouponListPage", path: prefix, component: CouponListPage }
];
